if (!customElements.get('product-set')) {
  customElements.define('product-set', class extends HTMLElement {
    constructor() {
      super();
      
      this.formId = this.dataset.productFormId;
      this.form = document.querySelector(`form[id="${this.formId}"]`);
      this.totalPrice = document.querySelector('.total-price');
      this.mainProductId = this.dataset.productId;
      this.mainVariantId = this.dataset.productVariantId;

      this.setItems = this.querySelectorAll('.product-addon-item__checkbox');
      this.productPrice = this.dataset.productPrice;
      this.productCurrency = this.dataset.productCurrency;
      this.productMoneyFormat = this.dataset.productMoneyFormat;
      this.productSetDiscountAmount = this.dataset.productSetDiscountAmount;
      this.productSetDiscountType = this.dataset.productSetDiscountType;
      this.minimumQuantity = this.dataset.productSetRequiredItems; // this.dataset.minimumQuantity // Minimum quantity to apply discount;

      this.init();
    }

    init() {
      if (!this.setItems) return;

      this.setItems.forEach(item => {
        item.addEventListener('change', (e) => {
          this.handleSetItemChange(item);
          this.updatePrice();
        });
      });

      this.initSelectedItemsToForm();
      this.updatePrice();
      this.removeMainProductFromForm();
    }

    initSelectedItemsToForm() {
      this.setItems.forEach(item => {
        if (item.checked) {
          this.addAddonToForm(item.dataset.addonId, 1);
        }
      });
    }

    handleSetItemChange(item) {
      // If unchecking and would go below minimum, prevent and recheck
      if (!item.checked) {
        const checkedCount = Array.from(this.setItems).filter(item => item.checked).length;
        if (checkedCount < this.minimumQuantity) {
          item.checked = true;
          alert(`You must select at least ${this.minimumQuantity} to purchase this set`);
          return;
        }
      }

      const itemId = item.dataset.addonId;
      const quantity = 1;

      if (item.checked) {
        this.addAddonToForm(itemId, quantity);
      } else {
        this.removeAddonFromForm(itemId);
      }
    }

    addAddonToForm(addonId, quantity) {
      const existingInput = this.form.querySelector(`input[name="items[][id]"][value="${addonId}"]`);

      if (!existingInput) {
        // Add hidden inputs for the addon
        const idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'items[][id]';
        idInput.value = addonId;

        const quantityInput = document.createElement('input');
        quantityInput.type = 'hidden';
        quantityInput.name = 'items[][quantity]';
        quantityInput.value = quantity;

        // Add properties to link addon with main product
        const propertyInput = document.createElement('input');
        propertyInput.type = 'hidden';
        propertyInput.name = 'items[][properties][_parent_id]';
        propertyInput.value = this.mainProductVariantId;

        const container = document.createElement('div');
        container.classList.add('addon-inputs');
        container.dataset.addonId = addonId;
        container.appendChild(idInput);
        container.appendChild(quantityInput);
        container.appendChild(propertyInput);

        this.form.appendChild(container);
      }
    }

    removeAddonFromForm(addonId) {
      const container = this.form.querySelector(`.addon-inputs[data-addon-id="${addonId}"]`);
      if (container) {
        container.remove();
      }
    }

    updatePrice() {
      let regularPrice = 0;
      let total = 0;
      let discount = 0;
      let checkedItems = 0;

      this.setItems.forEach(item => {
        if (item.checked) {
          checkedItems++;
          const price = parseFloat(item.dataset.addonPrice);
          total += price;
          regularPrice = total;
        }
      });

      if (this.productSetDiscountAmount > 0 && this.productSetDiscountType !== 'none' && checkedItems >= this.minimumQuantity) {
        const discountValue = this.productSetDiscountAmount;
        switch (this.productSetDiscountType) {
          case 'percentage':
            discount = total * (discountValue / 100);
            break;
          case 'amount':
            discount = discountValue;
            break;
          default:
            break;
        }
        total -= discount;
      }

      this.renderProductPrice(total, regularPrice, discount);

      // TODO: Implement Dispatch Event
      // const badgeText = regularPrice > total ? this.getDiscountPriceHtml(discount, this.productSetDiscountType) : null;
      // const discountText = discount > 0 ? this.getDiscountPriceHtml(discount, this.productSetDiscountType) : null;

      // this.dispatchEvent(new CustomEvent('price:updated', {
      //   bubbles: true, detail: {
      //     variant_id: this.mainVariantId,
      //     compare_at_price: regularPrice > total ? regularPrice : null,
      //     price: total,
      //     badge: badgeText ? { type: 'sale', text: badgeText } : null,
      //     discount: discountText ? { type: 'discount', text: discountText } : null,
      //     reset: total == this.productPrice,
      //     addons: checkedItems > 0 ? checkedItems : null
      //   }
      // }));

      if (typeof updateKlarnaPlacement === 'function') {
        updateKlarnaPlacement(total);
      }

    }

    renderProductPrice(total,regularPrice,discount) {

      const productPrices = document.querySelectorAll('.product__price');
      productPrices.forEach(price => {
        if (total > 0 && discount > 0) {
          price.querySelector('.price').classList.add('price--on-sale');
          price.querySelector('.price__badge-sale').textContent = this.getDiscountPriceHtml(this.productSetDiscountAmount, this.productSetDiscountType);
          price.querySelector('.price-item--sale').textContent = Shopify.renderPriceText(total);
        } else {
          price.querySelector('.price').classList.remove('price--on-sale');
          price.querySelector('.price__badge-sale').textContent = "";
          price.querySelector('.price-item--sale').textContent = "";
        }

        price.querySelectorAll('.price-item--regular').forEach(item => {
          item.textContent = Shopify.renderPriceText(regularPrice);
        });
      });

    }

    getDiscountPriceHtml(value, type) {
      if (type === 'percentage') {
        return 'Save ' + parseFloat(value) + '%';
      } else {
        return 'Save ' + value;
      }
    }

    removeMainProductFromForm() {
      const mainVariantInput = this.form.querySelector(`input[name="id"][value="${this.mainVariantId}"]`);
      if (mainVariantInput) {
        mainVariantInput.disabled = true;
      }
    }
  });
}